var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _circle, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinanceOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 160",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ov-grad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3b82f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1e40af"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 24,
    width: 160,
    height: 112,
    rx: 14,
    fill: "#fff",
    stroke: "#dbeafe",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 40,
    width: 48,
    height: 6,
    rx: 3,
    fill: "#bfdbfe"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 52,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#dbeafe"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 108,
    width: 16,
    height: 20,
    rx: 4,
    fill: "#bfdbfe"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 96,
    width: 16,
    height: 32,
    rx: 4,
    fill: "#93c5fd"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 84,
    width: 16,
    height: 44,
    rx: 4,
    fill: "url(#ov-grad)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 92,
    width: 16,
    height: 36,
    rx: 4,
    fill: "#3b82f6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 76,
    width: 16,
    height: 52,
    rx: 4,
    fill: "#2563eb"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 40,
    width: 20,
    height: 20,
    rx: 6,
    fill: "#ecfdf5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154 50 L158 54 L166 46",
    stroke: "#10b981",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 120,
    r: 22,
    fill: "url(#ov-grad)",
    fillOpacity: 0.15
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 168,
    y: 126,
    textAnchor: "middle",
    fill: "#1e40af",
    fontSize: 18,
    fontWeight: 700,
    fontFamily: "Inter,sans-serif"
  }, "?")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceOverview);
export default __webpack_public_path__ + "static/media/finance-overview.174b38cb91238a78d9b312683adf1d51.svg";
export { ForwardRef as ReactComponent };